"use client"
/* */
import { isObjectType, isString } from 'remeda';

function isRemoteComponentRendererProps(props) {
  return isObjectType(props) && "element" in props && "components" in props && "receiver" in props;
}
function isRemoteTextRenderProps(props) {
  return isObjectType(props) && "remote" in props && isObjectType(props.remote) && "data" in props.remote && isString(props.remote.data);
}

export { isRemoteComponentRendererProps, isRemoteTextRenderProps };
//# sourceMappingURL=remote.mjs.map
